//@flow
import React from "react"
import {observer} from "mobx-react"
import {FormattedMessage} from "react-intl"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"

import XsButton from "../../../../../global/ui/xsButton/xsButton"
import renderHTML from "react-render-html"
import StornoPrescriptionDialogStore from "../../../stores/StornoPrescriptionDialogStore"

@observer
export default class StornoPrescriptionDialog extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<Dialog
				id="xsConfirmInteraction"
				className="dialog-cancel-prescription"
				open={StornoPrescriptionDialogStore.isOpen}
				onClose={() => StornoPrescriptionDialogStore.close()}
				//onEscapeKeyDown={() => DrugInteractionsDialogStore.close()}
				disableBackdropClick={true}
				maxWidth="md"
			>
				<DialogTitle className={StornoPrescriptionDialogStore.isWarning ? "xs-warning-header" : ""}>
					<div className="nx-generika-header">
						<div className="nx-header-title">
							<FormattedMessage id="Calendar.stornoPrescription.dialog.headerMessage" />
						</div>
					</div>
				</DialogTitle>
				<DialogContent>
					<div className="nx-body">
						{renderHTML(StornoPrescriptionDialogStore.warning)}
						{StornoPrescriptionDialogStore.isWarning ? (
							<span>
								<br />
								<FormattedMessage id="Patient.stronoPrescription.areUsure" />{" "}
							</span>
						) : (
							<span className="dialog-cancel-success-message">
								{" "}
								{StornoPrescriptionDialogStore.warning && <br />}
								{StornoPrescriptionDialogStore.isInvalidate
									? "Zneplatnenie prebehlo úspešne"
									: "Storno prebehlo úspešne"}
							</span>
						)}
					</div>
				</DialogContent>
				<DialogActions>
					{!StornoPrescriptionDialogStore.isWarning && (
						<div className="xs-button">
							<XsButton
								className="xs-success xs-outline action-ok"
								text={<FormattedMessage id="Common.label.ok" />}
								onClick={() => StornoPrescriptionDialogStore.close()}
							/>
						</div>
					)}
					{StornoPrescriptionDialogStore.isWarning && (
						<div className="xs-button">
							<XsButton
								className="xs-success xs-outline action-decline"
								text={<FormattedMessage id="Common.dialog.No" />}
								onClick={() => StornoPrescriptionDialogStore.revertDelete()}
							/>
							<XsButton
								className="xs-danger xs-outline action-proceed"
								text={<FormattedMessage id="Common.dialog.Yes" />}
								onClick={() => StornoPrescriptionDialogStore.close()}
							/>
						</div>
					)}
				</DialogActions>
			</Dialog>
		)
	}
}
